import classNames from 'clsx';

const getMarginClassNames = map => {
  const {
    top,
    right,
    bottom,
    left,
    horizontal,
    vertical,
    all
  } = map;
  return classNames(typeof top === 'number' && `Margin-top--${top}`, typeof right === 'number' && `Margin-right--${right}`, typeof bottom === 'number' && `Margin-bottom--${bottom}`, typeof left === 'number' && `Margin-left--${left}`, typeof horizontal === 'number' && `Margin-horizontal--${horizontal}`, typeof vertical === 'number' && `Margin-vertical--${vertical}`, typeof all === 'number' && `Margin-all--${all}`);
};

export default getMarginClassNames;